import { createStore, compose } from "redux";
import { flatten } from "flat";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
  SET_DATA,
  SET_DATA_EQUIPMENT,
  SET_DATA_FIREEQUIPMENT,
  RESET_DATA,
  SET_LOCALSTORAGE_DATA,
  COPYDATA_ARCHITECTURE,
  COPYDATA_EQUIPMENT,
  COPYDATA_FIREEQUIPMENT,
} from "../Components/Parts/Word";

import { initialState } from "./InitialState";
import { architectureDataSet } from "./architectureDataSet";
import { equipmentDataSet } from "./equipmentDataSet";
import { fireProtectionFacilityDataSet } from "./fireProtectionFacilityDataSet";

const buildNewState = (state, section, bulding, page, payload) => ({
  ...state,
  [section]: {
    ...state[section],
    [bulding]: {
      ...state[section][bulding],
      [page]: {
        ...state[section][bulding]?.[page],
        ...payload,
      },
    },
  },
});

const setSectionData = (state, section, bulding, payload) => ({
  ...state,
  [section]: {
    ...state[section],
    [bulding]: payload,
  },
});

const copyPageData = (state, section, bulding, page, page_moto) => ({
  ...state,
  [section]: {
    ...state[section],
    [bulding]: {
      ...state[section][bulding],
      [page]: {
        ...state[section]["B1"][page_moto],
      },
    },
  },
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_DATA_ARCHITECTURE:
      return {
        ...state,
        Architecture: buildNewState(
          state,
          "Architecture",
          action.bulding,
          action.page,
          action.payload
        ).Architecture,
      };
    case CHANGE_DATA_EQUIPMENT:
      return {
        ...state,
        Equipment: buildNewState(
          state,
          "Equipment",
          action.bulding,
          action.page,
          action.payload
        ).Equipment,
      };
    case CHANGE_DATA_FIREEQUIPMENT:
      return {
        ...state,
        FireEquipment: buildNewState(
          state,
          "FireEquipment",
          action.bulding,
          action.page,
          action.payload
        ).FireEquipment,
      };
    case SET_DATA:
      return {
        ...state,
        Architecture: setSectionData(
          state,
          "Architecture",
          action.bulding,
          action.payload
        ).Architecture,
      };
    case SET_DATA_EQUIPMENT:
      return {
        ...state,
        Equipment: setSectionData(
          state,
          "Equipment",
          action.bulding,
          action.payload
        ).Equipment,
      };
    case SET_DATA_FIREEQUIPMENT:
      return {
        ...state,
        FireEquipment: setSectionData(
          state,
          "FireEquipment",
          action.bulding,
          action.payload
        ).FireEquipment,
      };
    case COPYDATA_ARCHITECTURE:
      return {
        ...state,
        Architecture: copyPageData(
          state,
          "Architecture",
          action.bulding,
          action.page,
          action.page_moto
        ).Architecture,
      };
    case COPYDATA_EQUIPMENT:
      return {
        ...state,
        Equipment: copyPageData(
          state,
          "Equipment",
          action.bulding,
          action.page,
          action.page_moto
        ).Equipment,
      };
    case COPYDATA_FIREEQUIPMENT:
      return {
        ...state,
        FireEquipment: copyPageData(
          state,
          "FireEquipment",
          action.bulding,
          action.page,
          action.page_moto
        ).FireEquipment,
      };
    case RESET_DATA:
      return initialState;
    case SET_LOCALSTORAGE_DATA:
      return action.payload;
    default:
      return state;
  }
};

const store = createStore(
  reducer,
  compose(
    process.env.NODE_ENV === "development" && window.devToolsExtension
      ? window.devToolsExtension()
      : (f) => f
  )
);

export default store;

// 🔁 共通ヘッダー生成関数
const createHeadersLabel = (dataSet) =>
  Object.keys(flatten(dataSet)).map((key) => ({ label: key, key }));

export const headersLabel_A = createHeadersLabel(architectureDataSet);
export const headersLabel_E = createHeadersLabel(equipmentDataSet);
export const headersLabel_F = createHeadersLabel(fireProtectionFacilityDataSet);
